import { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { Loading } from '@/components/uiParts/legacy/Loading'

const Root: NextPage = () => {
  const router = useRouter()

  useEffect(() => {
    router.replace('/user/login')
  }, [])

  return <Loading />
}

export default Root
